import { useEffect } from 'react';

import { toast } from '@hivebrite/design-system/Toast';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

import type { UseRenewProps } from '../types';

export const useRenew = ({ isActive, jobId }: UseRenewProps) => {
  const { currentUser } = useDefaultAppContexts();

  useEffect(() => {
    if (isActive && currentUser) {
      axios
        .get(
          Routes.renew_user_business_opportunities_request_path(
            currentUser.id,
            jobId,
          ),
        )
        .then(() =>
          toast.success(s__('JobForm|Your offer/request was renewed')),
        )
        .catch((err) => {
          toast.error(
            s__('JobForm|An error occurred while renewing your opportunity'),
          );

          /* eslint-disable-next-line no-console */
          console.error(err);
        });
    }
  }, [currentUser, isActive, jobId]);
};
